import { Action, ActionCreator, Dispatch } from "redux";
import { ThunkAction } from "redux-thunk";

import { DefaultErrorMessage, ZomentumEntities } from "@/Contracts";
import {
	Opportunity,
	OpportunityRequest,
	AddOpportunityRequest,
	EditOpportunityRequest,
	OpportunityView,
	FetchOpportunityForStageIdRequest,
	GetSyncErrorsInterface,
	allSyncErrors,
	ShareOpportunityWithVendorRequest,
	getOpportunityCurrencyCode
} from "@/Contracts/Opportunity";

import { Document, RecentDocumentItemView } from "@/Contracts/Documents";
import { RecentActivityItemView } from "@/Contracts/Others/RecentActivityFeed";

import {
	getOpportunities,
	getOpportunityDetails,
	addOpportunity,
	deleteOpportunity,
	editOpportunity,
	createOpportunityView,
	deleteOpportunityView,
	getAllOpportunityViews,
	getOpportunityListPost,
	getOpportunityViewMetadata,
	updateOpportunityView,
	getOpportunitiesForKanbanPost,
	getOpportunitiesCountForKanbanPost,
	getOpportunityDocuments,
	getSyncErrors,
	shareOpportunityWithVendor
} from "@/Services/Opportunity";
import { getRecentDocumentsByOpportunityIds } from "@/Services/Documents";
import { getRecentActivitiesByOpportunityIds } from "@/Services/Others/RecentActivityFeed";
import { DropResult } from "react-beautiful-dnd";
import { KanbanState } from "@/Reducers/Opportunity";
import { reorder, move } from "@/Components/Utils";
import { ChildEntityHydrationParams } from "@/Contracts/Utils";
import {
	CustomViewsMetadata,
	CustomViewResponse,
	CustomView,
	ListPagePostRequest,
	CustomViewFilterCriteria,
	BulkDeleteRecordsRequest,
	BulkUpdateRecordsRequest
} from "@/Contracts/UI";
import { SalesActivityAutomationMetadataFilterOperator } from "@/Contracts/Others/SalesActivity";

import { GlobalState } from "@/Reducers/interface";
import { bulkDeleteRecords, bulkUpdateRecords } from "@/Services/Settings";
import {
	getUpdatedFiltersWithPipelineFilters,
	isAllPipelinesFilter
} from "@/Utils/Opportunity";
import { areFiltersChanged, filterOutFormulaFields } from "@/Utils/common";

export enum OpportunitiesActionTypes {
	SHOW_OPPORTUNITIES_LOADER = "SHOW_OPPORTUNITIES_LOADER",
	HIDE_OPPORTUNITIES_LOADER = "HIDE_OPPORTUNITIES_LOADER",
	OPPORTUNITIES_REQUESTED = "OPPORTUNITIES_REQUESTED",
	OPPORTUNITIES_SUCCESSFUL = "OPPORTUNITIES_SUCCESSFUL",
	OPPORTUNITIES_FAILED = "OPPORTUNITIES_FAILED",
	OPPORTUNITIES_RESET = "OPPORTUNITIES_RESET",
	OPPORTUNITY_DETAILS_REQUESTED = "OPPORTUNITY_DETAILS_REQUESTED",
	OPPORTUNITY_DETAILS_SUCCESSFUL = "OPPORTUNITY_DETAILS_SUCCESSFUL",
	OPPORTUNITY_DETAILS_FAILED = "OPPORTUNITY_DETAILS_FAILED",
	OPPORTUNITY_DETAILS_RESET = "OPPORTUNITY_DETAILS_RESET",
	DELETE_OPPORTUNITY_REQUESTED = "DELETE_OPPORTUNITY_REQUESTED",
	DELETE_OPPORTUNITY_SUCCESSFUL = "DELETE_OPPORTUNITY_SUCCESSFUL",
	DELETE_OPPORTUNITY_FAILED = "DELETE_OPPORTUNITY_FAILED",
	ADD_OPPORTUNITY_REQUESTED = "ADD_OPPORTUNITY_REQUESTED",
	ADD_OPPORTUNITY_SUCCESSFUL = "ADD_OPPORTUNITY_SUCCESSFUL",
	ADD_OPPORTUNITY_FAILED = "ADD_OPPORTUNITY_FAILED",
	EDIT_OPPORTUNITY_REQUESTED = "EDIT_OPPORTUNITY_REQUESTED",
	EDIT_OPPORTUNITY_SUCCESSFUL = "EDIT_OPPORTUNITY_SUCCESSFUL",
	EDIT_OPPORTUNITY_FAILED = "EDIT_OPPORTUNITY_FAILED",
	OPPORTUNITY_DETAILS_UPDATED = "OPPORTUNITY_DETAILS_UPDATED",
	ADD_OPPORTUNITY_DRAWER_OPENED = "ADD_OPPORTUNITY_DRAWER_OPENED",
	ADD_OPPORTUNITY_DRAWER_CLOSED = "ADD_OPPORTUNITY_DRAWER_CLOSED",
	EDIT_OPPORTUNITY_DRAWER_OPENED = "EDIT_OPPORTUNITY_DRAWER_OPENED",
	EDIT_OPPORTUNITY_DRAWER_CLOSED = "EDIT_OPPORTUNITY_DRAWER_CLOSED",
	OPPORTUNITY_LIST_DRAWER_OPENED = "OPPORTUNITY_LIST_DRAWER_OPENED",
	OPPORTUNITY_LIST_DRAWER_CLOSED = "OPPORTUNITY_LIST_DRAWER_CLOSED",
	UPDATE_ACTIVE_OPPORTUNITY_VIEW = "UPDATE_ACTIVE_OPPORTUNITY_VIEW",
	RESTORE_OPPORTUNITY_STATE = "RESTORE_OPPORTUNITY_STATE",

	FETCH_UPDATED_OPPORTUNITY_REQUESTED = "FETCH_UPDATED_OPPORTUNITY_REQUESTED",
	FETCH_UPDATED_OPPORTUNITY_SUCCESSFUL = "FETCH_UPDATED_OPPORTUNITY_SUCCESSFUL",
	FETCH_UPDATED_OPPORTUNITY_FAILED = "FETCH_UPDATED_OPPORTUNITY_FAILED",

	FETCH_OPPORTUNITY_KANBAN_REQUESTED = "FETCH_OPPORTUNITY_KANBAN_REQUESTED",
	FETCH_OPPORTUNITY_KANBAN_SUCCESSFUL = "FETCH_OPPORTUNITY_KANBAN_SUCCESSFUL",
	FETCH_OPPORTUNITY_KANBAN_FAILED = "FETCH_OPPORTUNITY_KANBAN_FAILED",

	SHOW_LOADER_FOR_OPPORTUNITY_STAGE = "SHOW_LOADER_FOR_OPPORTUNITY_STAGE",
	HIDE_LOADER_FOR_OPPORTUNITY_STAGE = "HIDE_LOADER_FOR_OPPORTUNITY_STAGE",

	UPDATE_OPPORTUNITY_KANBAN_REQUESTED = "UPDATE_OPPORTUNITY_KANBAN_REQUESTED",
	UPDATE_OPPORTUNITY_KANBAN_SUCCESSFUL = "UPDATE_OPPORTUNITY_KANBAN_SUCCESSFUL",
	UPDATE_OPPORTUNITY_KANBAN_FAILED = "UPDATE_OPPORTUNITY_KANBAN_FAILED",

	RESET_OPPORTUNITY_KANBAN = "RESET_OPPORTUNITY_KANBAN",

	OPEN_EDIT_KANBAN_OPPORTUNITY_DRAWER = "OPEN_EDIT_KANBAN_OPPORTUNITY_DRAWER",
	CLOSE_EDIT_KANBAN_OPPORTUNITY_DRAWER = "CLOSE_EDIT_KANBAN_OPPORTUNITY_DRAWER",

	UPDATE_OPPORTUNITY_ON_KANBAN = "UPDATE_OPPORTUNITY_ON_KANBAN",
	DELETE_OPPORTUNITY_ON_KANBAN = "DELETE_OPPORTUNITY_ON_KANBAN",
	ADD_OPPORTUNITY_ON_KANBAN = "ADD_OPPORTUNITY_ON_KANBAN",
	UPDATE_OPPORTUNITY_USER_FILTER = "UPDATE_OPPORTUNITY_USER_FILTER",

	FETCH_ALL_OPPORTUNITIES_FOR_KANBAN_REQUESTED = "FETCH_ALL_OPPORTUNITIES_FOR_KANBAN_REQUESTED",
	FETCH_ALL_OPPORTUNITIES_FOR_KANBAN_SUCCESSFUL = "FETCH_ALL_OPPORTUNITIES_FOR_KANBAN_SUCCESSFUL",
	FETCH_ALL_OPPORTUNITIES_FOR_KANBAN_FAILED = "FETCH_ALL_OPPORTUNITIES_FOR_KANBAN_FAILED",

	FETCH_ALL_OPPORTUNITIES_COUNT_FOR_KANBAN_REQUESTED = "FETCH_ALL_OPPORTUNITIES_COUNT_FOR_KANBAN_REQUESTED",
	FETCH_ALL_OPPORTUNITIES_COUNT_FOR_KANBAN_SUCCESSFUL = "FETCH_ALL_OPPORTUNITIES_COUNT_FOR_KANBAN_SUCCESSFUL",
	FETCH_ALL_OPPORTUNITIES_COUNT_FOR_KANBAN_FAILED = "FETCH_ALL_OPPORTUNITIES_COUNT_FOR_KANBAN_FAILED",
	UPDATE_OPPORTUNITY_DOCUMENT = "UPDATE_OPPORTUNITY_DOCUMENT",

	FETCH_ALL_OPPORTUNITY_VIEWS_REQUESTED = "FETCH_ALL_OPPORTUNITY_VIEWS_REQUESTED",
	FETCH_ALL_OPPORTUNITY_VIEWS_SUCCESSFUL = "FETCH_ALL_OPPORTUNITY_VIEWS_SUCCESSFUL",
	FETCH_ALL_OPPORTUNITY_VIEWS_FAILED = "FETCH_ALL_OPPORTUNITY_VIEWS_FAILED",

	FETCH_OPPORTUNITY_VIEW_METADATA_REQUESTED = "FETCH_OPPORTUNITY_VIEW_METADATA_REQUESTED",
	FETCH_OPPORTUNITY_VIEW_METADATA_SUCCESSFUL = "FETCH_OPPORTUNITY_VIEW_METADATA_SUCCESSFUL",
	FETCH_OPPORTUNITY_VIEW_METADATA_FAILED = "FETCH_OPPORTUNITY_VIEW_METADATA_FAILED",

	FETCH_OPPORTUNITY_LIST_REQUESTED = "FETCH_OPPORTUNITY_LIST_REQUESTED",
	FETCH_OPPORTUNITY_LIST_SUCCESSFUL = "FETCH_OPPORTUNITY_LIST_SUCCESSFUL",
	FETCH_OPPORTUNITY_LIST_FAILED = "FETCH_OPPORTUNITY_LIST_FAILED",

	UPDATE_OPPORTUNITY_CURRENT_ACTIVE_VIEW = "UPDATE_OPPORTUNITY_CURRENT_ACTIVE_VIEW",

	CREATE_OPPORTUNITY_VIEW_REQUESTED = "CREATE_OPPORTUNITY_VIEW_REQUESTED",
	CREATE_OPPORTUNITY_VIEW_SUCCESSFUL = "CREATE_OPPORTUNITY_VIEW_SUCCESSFUL",
	CREATE_OPPORTUNITY_VIEW_FAILED = "CREATE_OPPORTUNITY_VIEW_FAILED",

	UPDATE_OPPORTUNITY_VIEW_REQUESTED = "UPDATE_OPPORTUNITY_VIEW_REQUESTED",
	UPDATE_OPPORTUNITY_VIEW_SUCCESSFUL = "UPDATE_OPPORTUNITY_VIEW_SUCCESSFUL",
	UPDATE_OPPORTUNITY_VIEW_FAILED = "UPDATE_OPPORTUNITY_VIEW_FAILED",

	DELETE_OPPORTUNITY_VIEW_REQUESTED = "DELETE_OPPORTUNITY_VIEW_REQUESTED",
	DELETE_OPPORTUNITY_VIEW_SUCCESSFUL = "DELETE_OPPORTUNITY_VIEW_SUCCESSFUL",
	DELETE_OPPORTUNITY_VIEW_FAILED = "DELETE_OPPORTUNITY_VIEW_FAILED",

	BULK_ACTION_RECORDS_SELECTED = "BULK_ACTION_RECORDS_SELECTED",
	BULK_ACTION_RECORDS_RESET = "BULK_ACTION_RECORDS_RESET",

	BULK_DELETE_RECORDS_REQUESTED = "BULK_DELETE_RECORDS_REQUESTED",
	BULK_DELETE_RECORDS_SUCCESSFUL = "BULK_DELETE_RECORDS_SUCCESSFUL",
	BULK_DELETE_RECORDS_FAILED = "BULK_DELETE_RECORDS_FAILED",

	BULK_UPDATE_RECORDS_REQUESTED = "BULK_UPDATE_RECORDS_REQUESTED",
	BULK_UPDATE_RECORDS_SUCCESSFUL = "BULK_UPDATE_RECORDS_SUCCESSFUL",
	BULK_UPDATE_RECORDS_FAILED = "BULK_UPDATE_RECORDS_FAILED",
	RESET_OPPORTUNITY_CURRENT_ACTIVE_VIEW = "RESET_OPPORTUNITY_CURRENT_ACTIVE_VIEW",

	FETCH_OPPORTUNITY_DOCUMENTS_REQUESTED = "FETCH_OPPORTUNITY_DOCUMENTS_REQUESTED",
	FETCH_OPPORTUNITY_DOCUMENTS_SUCCESSFUL = "FETCH_OPPORTUNITY_DOCUMENTS_SUCCESSFUL",
	FETCH_OPPORTUNITY_DOCUMENTS_FAILED = "FETCH_OPPORTUNITY_DOCUMENTS_FAILED",

	GET_SYNC_ERRORS = "GET_SYNC_ERRORS",
	GET_SYNC_ERRORS_SUCCESSFULL = "GET_SYNC_ERRORS_SUCCESSFULL",
	GET_SYNC_ERRORS_FAILED = "GET_SYNC_ERRORS_FAILED",

	MERGE_RECENT_DOCUMENT_FOR_OPPORTUNITIES = "MERGE_RECENT_DOCUMENT_FOR_OPPORTUNITIES",
	MERGE_RECENT_ACTIVITY_FOR_OPPORTUNITIES = "MERGE_RECENT_ACTIVITY_FOR_OPPORTUNITIES"
}

export type ShowOpportunitiesLoaderAction =
	Action<OpportunitiesActionTypes.SHOW_OPPORTUNITIES_LOADER>;
export type HideOpportunitiesLoaderAction =
	Action<OpportunitiesActionTypes.HIDE_OPPORTUNITIES_LOADER>;
export type OpportunitiesRequestedAction =
	Action<OpportunitiesActionTypes.OPPORTUNITIES_REQUESTED>;
export interface OpportunitiesSuccessfulAction
	extends Action<OpportunitiesActionTypes.OPPORTUNITIES_SUCCESSFUL> {
	readonly opportunities: Opportunity[];
	readonly count: Record<string, number>;
}

export type OpportunitiesFailedAction =
	Action<OpportunitiesActionTypes.OPPORTUNITIES_FAILED>;
export type OpportunitiesResetAction =
	Action<OpportunitiesActionTypes.OPPORTUNITIES_RESET>;
export type OpportunityDetailsRequestedAction =
	Action<OpportunitiesActionTypes.OPPORTUNITY_DETAILS_REQUESTED>;

export interface OpportunityDetailsSuccessfulAction
	extends Action<OpportunitiesActionTypes.OPPORTUNITY_DETAILS_SUCCESSFUL> {
	readonly currentActiveOpportunity: Opportunity;
}
export type OpportunityDetailsFailedAction =
	Action<OpportunitiesActionTypes.OPPORTUNITY_DETAILS_FAILED>;
export type OpportunityDetailsResetAction =
	Action<OpportunitiesActionTypes.OPPORTUNITY_DETAILS_RESET>;
export type DeleteOpportunityRequestedAction =
	Action<OpportunitiesActionTypes.DELETE_OPPORTUNITY_REQUESTED>;
export interface DeleteOpportunitySuccessfulAction
	extends Action<OpportunitiesActionTypes.DELETE_OPPORTUNITY_SUCCESSFUL> {
	readonly deleteOpportunity: Opportunity;
}
export type DeleteOpportunityFailedAction =
	Action<OpportunitiesActionTypes.DELETE_OPPORTUNITY_FAILED>;
export type AddOpportunityRequestedAction =
	Action<OpportunitiesActionTypes.ADD_OPPORTUNITY_REQUESTED>;
export interface AddOpportunitySuccessfulAction
	extends Action<OpportunitiesActionTypes.ADD_OPPORTUNITY_SUCCESSFUL> {
	readonly addOpportunity: Opportunity;
}
export type AddOpportunityFailedAction =
	Action<OpportunitiesActionTypes.ADD_OPPORTUNITY_FAILED>;

export type EditOpportunityRequestedAction =
	Action<OpportunitiesActionTypes.EDIT_OPPORTUNITY_REQUESTED>;
export interface EditOpportunitySuccessfulAction
	extends Action<OpportunitiesActionTypes.EDIT_OPPORTUNITY_SUCCESSFUL> {
	readonly editOpportunity: Opportunity;
}
export type EditOpportunityFailedAction =
	Action<OpportunitiesActionTypes.EDIT_OPPORTUNITY_FAILED>;
export interface OpportunityDetailsUpdatedAction
	extends Action<OpportunitiesActionTypes.OPPORTUNITY_DETAILS_UPDATED> {
	readonly currentActiveOpportunity: Opportunity;
}
export type AddOpportunityDrawerOpenedAction =
	Action<OpportunitiesActionTypes.ADD_OPPORTUNITY_DRAWER_OPENED>;
export type AddOpportunityDrawerClosedAction =
	Action<OpportunitiesActionTypes.ADD_OPPORTUNITY_DRAWER_CLOSED>;
export type EditOpportunityDrawerOpenedAction =
	Action<OpportunitiesActionTypes.EDIT_OPPORTUNITY_DRAWER_OPENED>;
export type EditOpportunityDrawerClosedAction =
	Action<OpportunitiesActionTypes.EDIT_OPPORTUNITY_DRAWER_CLOSED>;
export type OpportunityListDrawerOpenedAction =
	Action<OpportunitiesActionTypes.OPPORTUNITY_LIST_DRAWER_OPENED>;
export type OpportunityListDrawerClosedAction =
	Action<OpportunitiesActionTypes.OPPORTUNITY_LIST_DRAWER_CLOSED>;

export interface UpdateActiveOpportunityViewAction
	extends Action<OpportunitiesActionTypes.UPDATE_ACTIVE_OPPORTUNITY_VIEW> {
	readonly activeView: OpportunityView;
}

export interface RestoreOpportunityStateAction
	extends Action<OpportunitiesActionTypes.RESTORE_OPPORTUNITY_STATE> {
	readonly opportunityState: {
		viewMode?: "list" | "kanban";
		currentActiveView?: CustomView;
		addDrawerOpen?: boolean;
		editDrawerOpen?: boolean;
	};
}

export type FetchOpportunityKanbanRequestedAction =
	Action<OpportunitiesActionTypes.FETCH_OPPORTUNITY_KANBAN_REQUESTED>;
export interface FetchOpportunityKanbanSuccessfulAction
	extends Action<OpportunitiesActionTypes.FETCH_OPPORTUNITY_KANBAN_SUCCESSFUL> {
	readonly stageId: string;
	readonly list: string[];
	readonly data?: Record<string, Opportunity>;
}
export type FetchOpportunityKanbanFailedAction =
	Action<OpportunitiesActionTypes.FETCH_OPPORTUNITY_KANBAN_FAILED>;

export type FetchUpdatedOpportunityRequestedAction =
	Action<OpportunitiesActionTypes.FETCH_UPDATED_OPPORTUNITY_REQUESTED>;
export interface FetchUpdatedOpportunitySuccessfulAction
	extends Action<OpportunitiesActionTypes.FETCH_UPDATED_OPPORTUNITY_SUCCESSFUL> {
	readonly opportunity: Opportunity;
}
export type FetchUpdatedOpportunityFailedAction =
	Action<OpportunitiesActionTypes.FETCH_UPDATED_OPPORTUNITY_FAILED>;

export interface ShowLoaderForOpportunityStageAction
	extends Action<OpportunitiesActionTypes.SHOW_LOADER_FOR_OPPORTUNITY_STAGE> {
	readonly stageId: string;
}
export interface HideLoaderForOpportunityStageAction
	extends Action<OpportunitiesActionTypes.HIDE_LOADER_FOR_OPPORTUNITY_STAGE> {
	readonly stageId: string;
}

export type UpdateOpportunityKanbanRequestedAction =
	Action<OpportunitiesActionTypes.UPDATE_OPPORTUNITY_KANBAN_REQUESTED>;
export interface UpdateOpportunityKanbanSuccessfulAction
	extends Action<OpportunitiesActionTypes.UPDATE_OPPORTUNITY_KANBAN_SUCCESSFUL> {
	kanban: Partial<KanbanState>;
}
export type UpdateOpportunityKanbanFailedAction =
	Action<OpportunitiesActionTypes.UPDATE_OPPORTUNITY_KANBAN_FAILED>;

export interface OpenEditKanbanOpportunityAction
	extends Action<OpportunitiesActionTypes.OPEN_EDIT_KANBAN_OPPORTUNITY_DRAWER> {
	editKanbanOpportunity: string;
}
export type CloseEditKanbanOpportunityAction =
	Action<OpportunitiesActionTypes.CLOSE_EDIT_KANBAN_OPPORTUNITY_DRAWER>;

export interface UpdateOpportunityOnKanbanAction
	extends Action<OpportunitiesActionTypes.UPDATE_OPPORTUNITY_ON_KANBAN> {
	opportunity: Opportunity;
}

export interface DeleteOpportunityOnKanbanAction
	extends Action<OpportunitiesActionTypes.DELETE_OPPORTUNITY_ON_KANBAN> {
	opportunityId: string;
	opportunityStageId: string;
	selectedEstimatedValue: number;
}

export interface AddOpportunityOnKanbanAction
	extends Action<OpportunitiesActionTypes.ADD_OPPORTUNITY_ON_KANBAN> {
	opportunity: Opportunity;
}
export interface UpdateOpportunityUserFilterAction
	extends Action<OpportunitiesActionTypes.UPDATE_OPPORTUNITY_USER_FILTER> {
	activeUsers: string[];
}

export type FetchAllOpportunitiesForKanbanRequestedAction =
	Action<OpportunitiesActionTypes.FETCH_ALL_OPPORTUNITIES_FOR_KANBAN_REQUESTED>;
export interface FetchAllOpportunitiesForKanbanSuccessfulAction
	extends Action<OpportunitiesActionTypes.FETCH_ALL_OPPORTUNITIES_FOR_KANBAN_SUCCESSFUL> {
	readonly kanban: Partial<KanbanState>;
}
export type FetchAllOpportunitiesForKanbanFailedAction =
	Action<OpportunitiesActionTypes.FETCH_ALL_OPPORTUNITIES_FOR_KANBAN_FAILED>;

export type FetchAllOpportunitiesCountForKanbanRequestedAction =
	Action<OpportunitiesActionTypes.FETCH_ALL_OPPORTUNITIES_COUNT_FOR_KANBAN_REQUESTED>;
export interface FetchAllOpportunitiesCountForKanbanSuccessfulAction
	extends Action<OpportunitiesActionTypes.FETCH_ALL_OPPORTUNITIES_COUNT_FOR_KANBAN_SUCCESSFUL> {
	readonly kanban: Partial<KanbanState>;
}
export type FetchAllOpportunitiesCountForKanbanFailedAction =
	Action<OpportunitiesActionTypes.FETCH_ALL_OPPORTUNITIES_COUNT_FOR_KANBAN_FAILED>;

export interface UpdateOpportunityDocumentAction
	extends Action<OpportunitiesActionTypes.UPDATE_OPPORTUNITY_DOCUMENT> {
	readonly documents: Document[];
}

export type FetchOpportunityViewMetadataRequested =
	Action<OpportunitiesActionTypes.FETCH_OPPORTUNITY_VIEW_METADATA_REQUESTED>;
export interface FetchOpportunityViewMetadataSuccessful
	extends Action<OpportunitiesActionTypes.FETCH_OPPORTUNITY_VIEW_METADATA_SUCCESSFUL> {
	readonly metadata: CustomViewsMetadata;
}
export type FetchOpportunityViewMetadataFailed =
	Action<OpportunitiesActionTypes.FETCH_OPPORTUNITY_VIEW_METADATA_FAILED>;

export type FetchAllOpportunityViewRequested =
	Action<OpportunitiesActionTypes.FETCH_ALL_OPPORTUNITY_VIEWS_REQUESTED>;
export interface FetchAllOpportunityViewSuccessful
	extends Action<OpportunitiesActionTypes.FETCH_ALL_OPPORTUNITY_VIEWS_SUCCESSFUL> {
	readonly viewList: CustomViewResponse;
}
export type FetchAllOpportunityViewFailed =
	Action<OpportunitiesActionTypes.FETCH_ALL_OPPORTUNITY_VIEWS_FAILED>;

export type FetchOpportunityListRequested =
	Action<OpportunitiesActionTypes.FETCH_OPPORTUNITY_LIST_REQUESTED>;
export interface FetchOpportunityListSuccessful
	extends Action<OpportunitiesActionTypes.FETCH_OPPORTUNITY_LIST_SUCCESSFUL> {
	readonly opportunityList: Opportunity[];
	readonly count: Record<string, number>;
}
export type FetchOpportunityListFailed =
	Action<OpportunitiesActionTypes.FETCH_OPPORTUNITY_LIST_FAILED>;

export interface UpdateCurrentActiveViewAction
	extends Action<OpportunitiesActionTypes.UPDATE_OPPORTUNITY_CURRENT_ACTIVE_VIEW> {
	readonly currentActiveView: CustomView;
	readonly isViewChanged: boolean;
}

export type CreateOpportunityViewRequestedAction =
	Action<OpportunitiesActionTypes.CREATE_OPPORTUNITY_VIEW_REQUESTED>;
export interface CreateOpportunityViewSuccessfulAction
	extends Action<OpportunitiesActionTypes.CREATE_OPPORTUNITY_VIEW_SUCCESSFUL> {
	readonly view: CustomView;
}
export type CreateOpportunityViewFailedAction =
	Action<OpportunitiesActionTypes.CREATE_OPPORTUNITY_VIEW_FAILED>;

export type UpdateOpportunityViewRequestedAction =
	Action<OpportunitiesActionTypes.UPDATE_OPPORTUNITY_VIEW_REQUESTED>;
export interface UpdateOpportunityViewSuccessfulAction
	extends Action<OpportunitiesActionTypes.UPDATE_OPPORTUNITY_VIEW_SUCCESSFUL> {
	readonly view: CustomView;
}
export type UpdateOpportunityViewFailedAction =
	Action<OpportunitiesActionTypes.UPDATE_OPPORTUNITY_VIEW_FAILED>;

export type DeleteOpportunityViewRequestedAction =
	Action<OpportunitiesActionTypes.DELETE_OPPORTUNITY_VIEW_REQUESTED>;
export interface DeleteOpportunityViewSuccessfulAction
	extends Action<OpportunitiesActionTypes.DELETE_OPPORTUNITY_VIEW_SUCCESSFUL> {
	readonly deletedView: CustomView;
	readonly initialView: CustomView;
}
export type DeleteOpportunityViewFailedAction =
	Action<OpportunitiesActionTypes.DELETE_OPPORTUNITY_VIEW_FAILED>;

export type ResetCurrentActiveViewAction =
	Action<OpportunitiesActionTypes.RESET_OPPORTUNITY_CURRENT_ACTIVE_VIEW>;

export type BulkActionRecordsSelectedAction =
	Action<OpportunitiesActionTypes.BULK_ACTION_RECORDS_SELECTED>;
export type BulkActionRecordsResetAction =
	Action<OpportunitiesActionTypes.BULK_ACTION_RECORDS_RESET>;

export type BulkDeleteRecordsRequestedAction =
	Action<OpportunitiesActionTypes.BULK_DELETE_RECORDS_REQUESTED>;
export type BulkDeleteRecordsSuccessfulAction =
	Action<OpportunitiesActionTypes.BULK_DELETE_RECORDS_SUCCESSFUL>;
export type BulkDeleteRecordsFailedAction =
	Action<OpportunitiesActionTypes.BULK_DELETE_RECORDS_FAILED>;

export type BulkUpdateRecordsRequestedAction =
	Action<OpportunitiesActionTypes.BULK_UPDATE_RECORDS_REQUESTED>;
export type BulkUpdateRecordsSuccessfulAction =
	Action<OpportunitiesActionTypes.BULK_UPDATE_RECORDS_SUCCESSFUL>;
export type BulkUpdateRecordsFailedAction =
	Action<OpportunitiesActionTypes.BULK_UPDATE_RECORDS_FAILED>;
export type FetchOpportunityDocumentRequestedAction =
	Action<OpportunitiesActionTypes.FETCH_OPPORTUNITY_DOCUMENTS_REQUESTED>;
export interface FetchOpportunityDocumentSuccessfulAction
	extends Action<OpportunitiesActionTypes.FETCH_OPPORTUNITY_DOCUMENTS_SUCCESSFUL> {
	readonly opportunity: Opportunity;
}
export type FetchOpportunityDocumentFailedAction =
	Action<OpportunitiesActionTypes.FETCH_OPPORTUNITY_DOCUMENTS_FAILED>;

export type GetSyncErrorsAction =
	Action<OpportunitiesActionTypes.GET_SYNC_ERRORS>;

export interface GetSyncErrorsSuccessfulAction
	extends Action<OpportunitiesActionTypes.GET_SYNC_ERRORS_SUCCESSFULL> {
	readonly errorResponse: allSyncErrors;
}
export type GetSyncErrorsFailedAction =
	Action<OpportunitiesActionTypes.GET_SYNC_ERRORS_FAILED>;

export type OpportunitiesActions =
	| ShowOpportunitiesLoaderAction
	| HideOpportunitiesLoaderAction
	| OpportunitiesRequestedAction
	| OpportunitiesSuccessfulAction
	| OpportunitiesFailedAction
	| OpportunitiesResetAction
	| OpportunityDetailsRequestedAction
	| OpportunityDetailsSuccessfulAction
	| OpportunityDetailsFailedAction
	| OpportunityDetailsResetAction
	| DeleteOpportunityRequestedAction
	| DeleteOpportunitySuccessfulAction
	| DeleteOpportunityFailedAction
	| AddOpportunityRequestedAction
	| AddOpportunitySuccessfulAction
	| AddOpportunityFailedAction
	| EditOpportunityRequestedAction
	| EditOpportunitySuccessfulAction
	| EditOpportunityFailedAction
	| OpportunityDetailsUpdatedAction
	| AddOpportunityDrawerOpenedAction
	| AddOpportunityDrawerClosedAction
	| EditOpportunityDrawerOpenedAction
	| EditOpportunityDrawerClosedAction
	| OpportunityListDrawerOpenedAction
	| OpportunityListDrawerClosedAction
	| UpdateActiveOpportunityViewAction
	| RestoreOpportunityStateAction
	| FetchUpdatedOpportunityRequestedAction
	| FetchUpdatedOpportunitySuccessfulAction
	| FetchUpdatedOpportunityFailedAction
	| FetchOpportunityKanbanRequestedAction
	| FetchOpportunityKanbanSuccessfulAction
	| FetchOpportunityKanbanFailedAction
	| ShowLoaderForOpportunityStageAction
	| HideLoaderForOpportunityStageAction
	| UpdateOpportunityKanbanRequestedAction
	| UpdateOpportunityKanbanSuccessfulAction
	| UpdateOpportunityKanbanFailedAction
	| OpenEditKanbanOpportunityAction
	| CloseEditKanbanOpportunityAction
	| UpdateOpportunityOnKanbanAction
	| DeleteOpportunityOnKanbanAction
	| AddOpportunityOnKanbanAction
	| UpdateOpportunityUserFilterAction
	| FetchAllOpportunitiesForKanbanRequestedAction
	| FetchAllOpportunitiesForKanbanSuccessfulAction
	| FetchAllOpportunitiesForKanbanFailedAction
	| FetchAllOpportunitiesCountForKanbanRequestedAction
	| FetchAllOpportunitiesCountForKanbanSuccessfulAction
	| FetchAllOpportunitiesCountForKanbanFailedAction
	| UpdateOpportunityDocumentAction
	| FetchOpportunityViewMetadataRequested
	| FetchOpportunityViewMetadataSuccessful
	| FetchOpportunityViewMetadataFailed
	| FetchAllOpportunityViewRequested
	| FetchAllOpportunityViewSuccessful
	| FetchAllOpportunityViewFailed
	| FetchOpportunityListRequested
	| FetchOpportunityListSuccessful
	| FetchOpportunityListFailed
	| UpdateCurrentActiveViewAction
	| CreateOpportunityViewRequestedAction
	| CreateOpportunityViewSuccessfulAction
	| CreateOpportunityViewFailedAction
	| UpdateOpportunityViewRequestedAction
	| UpdateOpportunityViewSuccessfulAction
	| UpdateOpportunityViewFailedAction
	| DeleteOpportunityViewRequestedAction
	| DeleteOpportunityViewSuccessfulAction
	| DeleteOpportunityViewFailedAction
	| ResetCurrentActiveViewAction
	| BulkActionRecordsSelectedAction
	| BulkActionRecordsResetAction
	| BulkDeleteRecordsRequestedAction
	| BulkDeleteRecordsSuccessfulAction
	| BulkDeleteRecordsFailedAction
	| BulkUpdateRecordsRequestedAction
	| BulkUpdateRecordsSuccessfulAction
	| BulkUpdateRecordsFailedAction
	| FetchOpportunityDocumentRequestedAction
	| FetchOpportunityDocumentSuccessfulAction
	| FetchOpportunityDocumentFailedAction
	| GetSyncErrorsAction
	| GetSyncErrorsSuccessfulAction
	| GetSyncErrorsFailedAction
	| MergeRecentDocumentForOpportunitiesAction
	| MergeRecentActivityForOpportunitiesAction;

export interface MergeRecentDocumentForOpportunitiesAction
	extends Action<OpportunitiesActionTypes.MERGE_RECENT_DOCUMENT_FOR_OPPORTUNITIES> {
	readonly map: Record<string, RecentDocumentItemView | null>;
}

export interface MergeRecentActivityForOpportunitiesAction
	extends Action<OpportunitiesActionTypes.MERGE_RECENT_ACTIVITY_FOR_OPPORTUNITIES> {
	readonly map: Record<string, RecentActivityItemView | null>;
}

export interface OpportunityDispatch {
	showOpportunitiesLoader: ActionCreator<
		ThunkAction<
			ShowOpportunitiesLoaderAction,
			GlobalState,
			null,
			ShowOpportunitiesLoaderAction
		>
	>;
	hideOpportunitiesLoader: ActionCreator<
		ThunkAction<
			HideOpportunitiesLoaderAction,
			GlobalState,
			null,
			HideOpportunitiesLoaderAction
		>
	>;
	openEditKanbanOpportunity: ActionCreator<
		ThunkAction<
			OpenEditKanbanOpportunityAction,
			GlobalState,
			string,
			OpenEditKanbanOpportunityAction
		>
	>;
	closeEditKanbanOpportunity: ActionCreator<
		ThunkAction<
			CloseEditKanbanOpportunityAction,
			GlobalState,
			null,
			CloseEditKanbanOpportunityAction
		>
	>;
	showOpportunityStageLoader: ActionCreator<
		ThunkAction<
			ShowLoaderForOpportunityStageAction,
			GlobalState,
			{ stageId: string },
			ShowLoaderForOpportunityStageAction
		>
	>;
	hideOpportunityStageLoader: ActionCreator<
		ThunkAction<
			HideLoaderForOpportunityStageAction,
			GlobalState,
			{ stageId: string },
			HideLoaderForOpportunityStageAction
		>
	>;
	getOpportunities: ActionCreator<
		ThunkAction<
			Promise<OpportunitiesSuccessfulAction>,
			GlobalState,
			OpportunityRequest,
			OpportunitiesSuccessfulAction
		>
	>;

	resetOpportunities: ActionCreator<
		ThunkAction<
			OpportunitiesResetAction,
			GlobalState,
			OpportunityRequest,
			OpportunitiesResetAction
		>
	>;
	getOpportunityDetails: ActionCreator<
		ThunkAction<
			Promise<OpportunityDetailsSuccessfulAction>,
			GlobalState,
			string,
			OpportunityDetailsSuccessfulAction
		>
	>;
	resetOpportunityDetails: ActionCreator<
		ThunkAction<
			OpportunityDetailsResetAction,
			GlobalState,
			null,
			OpportunityDetailsResetAction
		>
	>;
	deleteOpportunity: ActionCreator<
		ThunkAction<
			Promise<DeleteOpportunitySuccessfulAction>,
			GlobalState,
			Opportunity,
			DeleteOpportunitySuccessfulAction
		>
	>;
	addOpportunity: ActionCreator<
		ThunkAction<
			Promise<AddOpportunitySuccessfulAction>,
			GlobalState,
			AddOpportunityRequest,
			AddOpportunitySuccessfulAction
		>
	>;
	syncKanbanOpportunityDataById: ActionCreator<
		ThunkAction<
			Promise<FetchUpdatedOpportunitySuccessfulAction>,
			GlobalState,
			FetchOpportunityForStageIdRequest,
			FetchUpdatedOpportunitySuccessfulAction
		>
	>;
	fetchOpportunityForStageId: ActionCreator<
		ThunkAction<
			Promise<FetchOpportunityKanbanSuccessfulAction>,
			GlobalState,
			{
				stageId: string;
				fetchMoreOpportunitiesRequest: ListPagePostRequest;
			},
			FetchOpportunityKanbanSuccessfulAction
		>
	>;
	editOpportunity: ActionCreator<
		ThunkAction<
			Promise<EditOpportunitySuccessfulAction>,
			GlobalState,
			Opportunity,
			EditOpportunitySuccessfulAction
		>
	>;
	updateOpportunityDetails: ActionCreator<
		ThunkAction<
			OpportunityDetailsUpdatedAction,
			GlobalState,
			null,
			OpportunityDetailsUpdatedAction
		>
	>;
	addOpportunityDrawerOpened: ActionCreator<
		ThunkAction<
			AddOpportunityDrawerOpenedAction,
			GlobalState,
			null,
			AddOpportunityDrawerOpenedAction
		>
	>;
	addOpportunityDrawerClosed: ActionCreator<
		ThunkAction<
			AddOpportunityDrawerClosedAction,
			GlobalState,
			null,
			AddOpportunityDrawerClosedAction
		>
	>;
	editOpportunityDrawerOpened: ActionCreator<
		ThunkAction<
			EditOpportunityDrawerOpenedAction,
			GlobalState,
			null,
			EditOpportunityDrawerOpenedAction
		>
	>;
	editOpportunityDrawerClosed: ActionCreator<
		ThunkAction<
			EditOpportunityDrawerClosedAction,
			GlobalState,
			null,
			EditOpportunityDrawerClosedAction
		>
	>;
	opportunityListDrawerOpened: ActionCreator<
		ThunkAction<
			OpportunityListDrawerOpenedAction,
			GlobalState,
			null,
			OpportunityListDrawerOpenedAction
		>
	>;
	opportunityListDrawerClosed: ActionCreator<
		ThunkAction<
			OpportunityListDrawerClosedAction,
			GlobalState,
			null,
			OpportunityListDrawerClosedAction
		>
	>;
	updateActiveOpportunityView: ActionCreator<
		ThunkAction<
			UpdateActiveOpportunityViewAction,
			GlobalState,
			string,
			UpdateActiveOpportunityViewAction
		>
	>;
	restoreOpportunityState: ActionCreator<
		ThunkAction<
			RestoreOpportunityStateAction,
			GlobalState,
			any,
			RestoreOpportunityStateAction
		>
	>;
	reorderOpportunityInKanban: ActionCreator<
		ThunkAction<
			Promise<UpdateOpportunityOnKanbanAction>,
			GlobalState,
			DropResult,
			UpdateOpportunityOnKanbanAction
		>
	>;
	updateOpportunityOnKanban: ActionCreator<
		ThunkAction<
			UpdateOpportunityOnKanbanAction,
			GlobalState,
			Opportunity,
			UpdateOpportunityOnKanbanAction
		>
	>;
	acceptPendingOpportunity: ActionCreator<
		ThunkAction<
			AddOpportunityOnKanbanAction,
			GlobalState,
			Opportunity,
			AddOpportunityOnKanbanAction
		>
	>;
	deleteOpportunityOnKanban: ActionCreator<
		ThunkAction<
			DeleteOpportunityOnKanbanAction,
			GlobalState,
			{ opportunityId: string; opportunityStageId: string },
			DeleteOpportunityOnKanbanAction
		>
	>;
	updateActiveUsers: ActionCreator<
		ThunkAction<
			UpdateOpportunityUserFilterAction,
			GlobalState,
			string[],
			UpdateOpportunityUserFilterAction
		>
	>;
	fetchAllOpportunitiesForKanban: ActionCreator<
		ThunkAction<
			Promise<FetchAllOpportunitiesForKanbanSuccessfulAction>,
			GlobalState,
			ListPagePostRequest,
			FetchAllOpportunitiesForKanbanSuccessfulAction
		>
	>;
	fetchAllOpportunitiesCountForKanban: ActionCreator<
		ThunkAction<
			Promise<FetchAllOpportunitiesCountForKanbanSuccessfulAction>,
			GlobalState,
			ListPagePostRequest,
			FetchAllOpportunitiesCountForKanbanSuccessfulAction
		>
	>;
	updateOpportunityDocument: ActionCreator<
		ThunkAction<
			UpdateOpportunityDocumentAction,
			GlobalState,
			Document,
			UpdateOpportunityDocumentAction
		>
	>;
	fetchOpportunityViewMetadata: ActionCreator<
		ThunkAction<
			Promise<FetchOpportunityViewMetadataSuccessful>,
			GlobalState,
			null,
			FetchOpportunityViewMetadataSuccessful
		>
	>;
	fetchAllOpportunityView: ActionCreator<
		ThunkAction<
			Promise<FetchAllOpportunityViewSuccessful>,
			GlobalState,
			null,
			FetchAllOpportunityViewSuccessful
		>
	>;
	fetchAllOpportunities: ActionCreator<
		ThunkAction<
			Promise<FetchOpportunityListSuccessful>,
			GlobalState,
			ListPagePostRequest,
			FetchOpportunityListSuccessful
		>
	>;
	updateCurrentActiveView: ActionCreator<
		ThunkAction<
			UpdateCurrentActiveViewAction,
			GlobalState,
			{ selectCurrentActiveView: CustomView; discardingView?: boolean },
			UpdateCurrentActiveViewAction
		>
	>;
	createOpportunityView: ActionCreator<
		ThunkAction<
			Promise<CreateOpportunityViewSuccessfulAction>,
			GlobalState,
			CustomView,
			CreateOpportunityViewSuccessfulAction
		>
	>;
	updateOpportunityView: ActionCreator<
		ThunkAction<
			Promise<UpdateOpportunityViewSuccessfulAction>,
			GlobalState,
			CustomView,
			UpdateOpportunityViewSuccessfulAction
		>
	>;
	deleteOpportunityView: ActionCreator<
		ThunkAction<
			Promise<DeleteOpportunityViewSuccessfulAction>,
			GlobalState,
			{ deleteView: CustomView; initialView: CustomView },
			DeleteOpportunityViewSuccessfulAction
		>
	>;
	resetViews: ActionCreator<
		ThunkAction<
			ResetCurrentActiveViewAction,
			GlobalState,
			null,
			ResetCurrentActiveViewAction
		>
	>;
	bulkActionsRecordsSelected: ActionCreator<
		ThunkAction<
			BulkActionRecordsSelectedAction,
			GlobalState,
			null,
			BulkActionRecordsSelectedAction
		>
	>;
	bulkActionsRecordsReset: ActionCreator<
		ThunkAction<
			BulkActionRecordsResetAction,
			GlobalState,
			null,
			BulkActionRecordsResetAction
		>
	>;
	bulkDeleteRecords: ActionCreator<
		ThunkAction<
			Promise<BulkDeleteRecordsSuccessfulAction>,
			GlobalState,
			BulkDeleteRecordsRequest,
			BulkDeleteRecordsSuccessfulAction
		>
	>;
	bulkUpdateRecords: ActionCreator<
		ThunkAction<
			Promise<BulkUpdateRecordsSuccessfulAction>,
			GlobalState,
			BulkUpdateRecordsRequest,
			BulkUpdateRecordsSuccessfulAction
		>
	>;
	fetchDocumentRelatedToOpportunity: ActionCreator<
		ThunkAction<
			Promise<FetchOpportunityDocumentSuccessfulAction>,
			GlobalState,
			string,
			FetchOpportunityDocumentSuccessfulAction
		>
	>;

	getSyncErrors: ActionCreator<
		ThunkAction<
			Promise<GetSyncErrorsSuccessfulAction>,
			GlobalState,
			GetSyncErrorsInterface,
			GetSyncErrorsSuccessfulAction
		>
	>;

	fetchRecentDocumentByOpportunityIds: ActionCreator<
		ThunkAction<
			Promise<MergeRecentDocumentForOpportunitiesAction>,
			GlobalState,
			string[],
			MergeRecentDocumentForOpportunitiesAction
		>
	>;

	fetchRecentActivityByOpportunityIds: ActionCreator<
		ThunkAction<
			Promise<MergeRecentActivityForOpportunitiesAction>,
			GlobalState,
			string[],
			MergeRecentActivityForOpportunitiesAction
		>
	>;
}

export const OpportunitiesActionCreators: OpportunityDispatch = {
	getSyncErrors: (errorRequest: GetSyncErrorsInterface) => {
		return async (
			dispatch: Dispatch
		): Promise<GetSyncErrorsSuccessfulAction> => {
			const getSyncErrorRequestedAction: GetSyncErrorsAction = {
				type: OpportunitiesActionTypes.GET_SYNC_ERRORS
			};
			dispatch(getSyncErrorRequestedAction);
			try {
				const errorResponse = await getSyncErrors(errorRequest);
				const getSyncErrorSuccessfulAction: GetSyncErrorsSuccessfulAction =
					{
						type: OpportunitiesActionTypes.GET_SYNC_ERRORS_SUCCESSFULL,
						errorResponse
					};
				return dispatch(getSyncErrorSuccessfulAction);
			} catch (error) {
				const getSyncErrorFailedAction: GetSyncErrorsFailedAction = {
					type: OpportunitiesActionTypes.GET_SYNC_ERRORS_FAILED
				};
				dispatch(getSyncErrorFailedAction);
				return Promise.reject(error);
			}
		};
	},

	showOpportunitiesLoader: () => {
		return (dispatch: Dispatch): ShowOpportunitiesLoaderAction => {
			const showOpportunitiesLoaderAction: ShowOpportunitiesLoaderAction =
				{
					type: OpportunitiesActionTypes.SHOW_OPPORTUNITIES_LOADER
				};
			return dispatch(showOpportunitiesLoaderAction);
		};
	},
	hideOpportunitiesLoader: () => {
		return (dispatch: Dispatch): HideOpportunitiesLoaderAction => {
			const hideOpportunitiesLoaderAction: HideOpportunitiesLoaderAction =
				{
					type: OpportunitiesActionTypes.HIDE_OPPORTUNITIES_LOADER
				};
			return dispatch(hideOpportunitiesLoaderAction);
		};
	},
	openEditKanbanOpportunity: (opportunityId: string) => {
		return (dispatch: Dispatch): OpenEditKanbanOpportunityAction => {
			const openEditKanbanOpportunityAction: OpenEditKanbanOpportunityAction =
				{
					type: OpportunitiesActionTypes.OPEN_EDIT_KANBAN_OPPORTUNITY_DRAWER,
					editKanbanOpportunity: opportunityId
				};
			return dispatch(openEditKanbanOpportunityAction);
		};
	},
	closeEditKanbanOpportunity: () => {
		return (dispatch: Dispatch): CloseEditKanbanOpportunityAction => {
			const closeEditKanbanOpportunityAction: CloseEditKanbanOpportunityAction =
				{
					type: OpportunitiesActionTypes.CLOSE_EDIT_KANBAN_OPPORTUNITY_DRAWER
				};
			return dispatch(closeEditKanbanOpportunityAction);
		};
	},
	showOpportunityStageLoader: ({ stageId }) => {
		return (dispatch: Dispatch): ShowLoaderForOpportunityStageAction => {
			const showLoaderForOpportunityStageAction: ShowLoaderForOpportunityStageAction =
				{
					type: OpportunitiesActionTypes.SHOW_LOADER_FOR_OPPORTUNITY_STAGE,
					stageId
				};
			return dispatch(showLoaderForOpportunityStageAction);
		};
	},
	hideOpportunityStageLoader: ({ stageId }) => {
		return (dispatch: Dispatch): HideLoaderForOpportunityStageAction => {
			const hideLoaderForOpportunityStageAction: HideLoaderForOpportunityStageAction =
				{
					type: OpportunitiesActionTypes.HIDE_LOADER_FOR_OPPORTUNITY_STAGE,
					stageId
				};
			return dispatch(hideLoaderForOpportunityStageAction);
		};
	},
	getOpportunities: (
		opportunityRequest: OpportunityRequest,
		pipelineId?: string
	) => {
		return async (
			dispatch: Dispatch
		): Promise<OpportunitiesSuccessfulAction> => {
			const opportunitiesRequestedAction: OpportunitiesRequestedAction = {
				type: OpportunitiesActionTypes.OPPORTUNITIES_REQUESTED
			};
			dispatch(opportunitiesRequestedAction);
			try {
				const opportunitiesResponse = await getOpportunities(
					opportunityRequest,
					pipelineId
				);
				const opportunitiesSuccessfulAction: OpportunitiesSuccessfulAction =
					{
						type: OpportunitiesActionTypes.OPPORTUNITIES_SUCCESSFUL,
						opportunities: opportunitiesResponse.data,
						count: opportunitiesResponse.filtered_count_map
					};
				return dispatch(opportunitiesSuccessfulAction);
			} catch (error) {
				const opportunitiesFailedAction: OpportunitiesFailedAction = {
					type: OpportunitiesActionTypes.OPPORTUNITIES_FAILED
				};
				dispatch(opportunitiesFailedAction);

				return Promise.reject(error);
			}
		};
	},

	resetOpportunities: () => {
		return (dispatch: Dispatch) => {
			const opportunitiesResetAction: OpportunitiesResetAction = {
				type: OpportunitiesActionTypes.OPPORTUNITIES_RESET
			};
			return dispatch(opportunitiesResetAction);
		};
	},
	getOpportunityDetails: (opportunityId: string, includeBlocks = false) => {
		return async (
			dispatch: Dispatch
		): Promise<OpportunityDetailsSuccessfulAction> => {
			const opportunityDetailsRequestedAction: OpportunityDetailsRequestedAction =
				{
					type: OpportunitiesActionTypes.OPPORTUNITY_DETAILS_REQUESTED
				};
			dispatch(opportunityDetailsRequestedAction);
			try {
				const opportunitiesDetailsResponse =
					await getOpportunityDetails(opportunityId, includeBlocks);
				const opportunityDetailsSuccessfulAction: OpportunityDetailsSuccessfulAction =
					{
						type: OpportunitiesActionTypes.OPPORTUNITY_DETAILS_SUCCESSFUL,
						currentActiveOpportunity: opportunitiesDetailsResponse
					};
				return dispatch(opportunityDetailsSuccessfulAction);
			} catch (error) {
				const opportunityDetailsFailedAction: OpportunityDetailsFailedAction =
					{
						type: OpportunitiesActionTypes.OPPORTUNITY_DETAILS_FAILED
					};
				dispatch(opportunityDetailsFailedAction);

				return Promise.reject(error);
			}
		};
	},

	resetOpportunityDetails: () => {
		return (dispatch: Dispatch) => {
			const opportunityDetailsResetAction: OpportunityDetailsResetAction =
				{
					type: OpportunitiesActionTypes.OPPORTUNITY_DETAILS_RESET
				};
			return dispatch(opportunityDetailsResetAction);
		};
	},
	deleteOpportunity: (opportunity: Opportunity) => {
		return async (
			dispatch: Dispatch
		): Promise<DeleteOpportunitySuccessfulAction> => {
			const deleteOpportunityRequestedAction: DeleteOpportunityRequestedAction =
				{
					type: OpportunitiesActionTypes.DELETE_OPPORTUNITY_REQUESTED
				};
			dispatch(deleteOpportunityRequestedAction);
			try {
				const deleteOpportunityResponse = await deleteOpportunity(
					opportunity
				);
				if (deleteOpportunityResponse.deleted) {
					const deleteOpportunitySuccessfulAction: DeleteOpportunitySuccessfulAction =
						{
							type: OpportunitiesActionTypes.DELETE_OPPORTUNITY_SUCCESSFUL,
							deleteOpportunity: opportunity
						};
					return dispatch(deleteOpportunitySuccessfulAction);
				} else {
					const deleteOpportunityFailedAction: DeleteOpportunityFailedAction =
						{
							type: OpportunitiesActionTypes.DELETE_OPPORTUNITY_FAILED
						};
					dispatch(deleteOpportunityFailedAction);
					return Promise.reject(DefaultErrorMessage);
				}
			} catch (error) {
				const deleteOpportunityFailedAction: DeleteOpportunityFailedAction =
					{
						type: OpportunitiesActionTypes.DELETE_OPPORTUNITY_FAILED
					};
				dispatch(deleteOpportunityFailedAction);

				return Promise.reject(error);
			}
		};
	},
	addOpportunity: (
		addOpportunityRequest: AddOpportunityRequest,
		shareOpportunityWithVendorRequest?: ShareOpportunityWithVendorRequest
	) => {
		return async (
			dispatch: Dispatch
		): Promise<AddOpportunitySuccessfulAction> => {
			const addOpportunityRequestedAction: AddOpportunityRequestedAction =
				{
					type: OpportunitiesActionTypes.ADD_OPPORTUNITY_REQUESTED
				};
			dispatch(addOpportunityRequestedAction);
			try {
				let addOpportunityResponse;
				addOpportunityResponse = await addOpportunity(
					addOpportunityRequest
				);
				if (shareOpportunityWithVendorRequest) {
					addOpportunityResponse = await shareOpportunityWithVendor(
						addOpportunityResponse.id,
						shareOpportunityWithVendorRequest,
						addOpportunityRequest.included_child_entities
					);
				}
				const addOpportunitySuccessfulAction: AddOpportunitySuccessfulAction =
					{
						type: OpportunitiesActionTypes.ADD_OPPORTUNITY_SUCCESSFUL,
						addOpportunity: addOpportunityResponse
					};
				return dispatch(addOpportunitySuccessfulAction);
			} catch (error) {
				const addOpportunityFailedAction: AddOpportunityFailedAction = {
					type: OpportunitiesActionTypes.ADD_OPPORTUNITY_FAILED
				};
				dispatch(addOpportunityFailedAction);

				return Promise.reject(error);
			}
		};
	},
	editOpportunity: (
		editOpportunityRequest: EditOpportunityRequest,
		shareOpportunityWithVendorRequest?: ShareOpportunityWithVendorRequest
	) => {
		return async (
			dispatch: Dispatch
		): Promise<EditOpportunitySuccessfulAction> => {
			const editOpportunityRequestedAction: EditOpportunityRequestedAction =
				{
					type: OpportunitiesActionTypes.EDIT_OPPORTUNITY_REQUESTED
				};
			dispatch(editOpportunityRequestedAction);
			try {
				let editOpportunityResponse;
				editOpportunityResponse = await editOpportunity(
					editOpportunityRequest
				);
				if (shareOpportunityWithVendorRequest) {
					editOpportunityResponse = await shareOpportunityWithVendor(
						editOpportunityResponse.id,
						shareOpportunityWithVendorRequest,
						editOpportunityRequest.included_child_entities
					);
				}
				const editOpportunitySuccessfulAction: EditOpportunitySuccessfulAction =
					{
						type: OpportunitiesActionTypes.EDIT_OPPORTUNITY_SUCCESSFUL,
						editOpportunity: editOpportunityResponse
					};
				return dispatch(editOpportunitySuccessfulAction);
			} catch (error) {
				const editOpportunityFailedAction: EditOpportunityFailedAction =
					{
						type: OpportunitiesActionTypes.EDIT_OPPORTUNITY_FAILED
					};
				dispatch(editOpportunityFailedAction);

				return Promise.reject(error);
			}
		};
	},
	updateOpportunityDetails: (currentActiveOpportunity: Opportunity) => {
		return (dispatch: Dispatch): OpportunityDetailsUpdatedAction => {
			const opportunityDetailsUpdatedAction: OpportunityDetailsUpdatedAction =
				{
					type: OpportunitiesActionTypes.OPPORTUNITY_DETAILS_UPDATED,
					currentActiveOpportunity
				};
			return dispatch(opportunityDetailsUpdatedAction);
		};
	},
	addOpportunityDrawerOpened: () => (dispatch: Dispatch) => {
		const addOpportunityDrawerOpenedAction: AddOpportunityDrawerOpenedAction =
			{
				type: OpportunitiesActionTypes.ADD_OPPORTUNITY_DRAWER_OPENED
			};
		return dispatch(addOpportunityDrawerOpenedAction);
	},
	addOpportunityDrawerClosed: () => (dispatch: Dispatch) => {
		const addOpportunityDrawerClosedAction: AddOpportunityDrawerClosedAction =
			{
				type: OpportunitiesActionTypes.ADD_OPPORTUNITY_DRAWER_CLOSED
			};
		return dispatch(addOpportunityDrawerClosedAction);
	},
	editOpportunityDrawerOpened: () => {
		return (dispatch: Dispatch): EditOpportunityDrawerOpenedAction => {
			const editOpportunityOpenedAction: EditOpportunityDrawerOpenedAction =
				{
					type: OpportunitiesActionTypes.EDIT_OPPORTUNITY_DRAWER_OPENED
				};
			return dispatch(editOpportunityOpenedAction);
		};
	},
	editOpportunityDrawerClosed: () => {
		return (dispatch: Dispatch): EditOpportunityDrawerClosedAction => {
			const editOpportunityClosedAction: EditOpportunityDrawerClosedAction =
				{
					type: OpportunitiesActionTypes.EDIT_OPPORTUNITY_DRAWER_CLOSED
				};
			return dispatch(editOpportunityClosedAction);
		};
	},
	opportunityListDrawerOpened: () => {
		return (dispatch: Dispatch): OpportunityListDrawerOpenedAction => {
			const opportunityListDrawerOpenedAction: OpportunityListDrawerOpenedAction =
				{
					type: OpportunitiesActionTypes.OPPORTUNITY_LIST_DRAWER_OPENED
				};
			return dispatch(opportunityListDrawerOpenedAction);
		};
	},
	opportunityListDrawerClosed: () => {
		return (dispatch: Dispatch): OpportunityListDrawerClosedAction => {
			const opportunityListDrawerClosedAction: OpportunityListDrawerClosedAction =
				{
					type: OpportunitiesActionTypes.OPPORTUNITY_LIST_DRAWER_CLOSED
				};
			return dispatch(opportunityListDrawerClosedAction);
		};
	},
	updateActiveOpportunityView: (activeView: OpportunityView) => {
		return (dispatch: Dispatch): UpdateActiveOpportunityViewAction => {
			const updateActiveOpportunityViewAction: UpdateActiveOpportunityViewAction =
				{
					type: OpportunitiesActionTypes.UPDATE_ACTIVE_OPPORTUNITY_VIEW,
					activeView
				};
			return dispatch(updateActiveOpportunityViewAction);
		};
	},
	restoreOpportunityState: (opportunityState: any) => {
		return (dispatch: Dispatch): RestoreOpportunityStateAction => {
			const restoreOpportunityStateAction: RestoreOpportunityStateAction =
				{
					type: OpportunitiesActionTypes.RESTORE_OPPORTUNITY_STATE,
					opportunityState
				};
			return dispatch(restoreOpportunityStateAction);
		};
	},
	syncKanbanOpportunityDataById: (opportunityId: string) => {
		return async (
			dispatch: Dispatch
		): Promise<FetchUpdatedOpportunitySuccessfulAction> => {
			const fetchUpdatedOpportunityRequestedAction: FetchUpdatedOpportunityRequestedAction =
				{
					type: OpportunitiesActionTypes.FETCH_UPDATED_OPPORTUNITY_REQUESTED
				};
			dispatch(fetchUpdatedOpportunityRequestedAction);
			try {
				const updatedOpportunityResponse = await getOpportunityDetails(
					opportunityId
				);
				const opportunityDetailsSuccessfulAction: FetchUpdatedOpportunitySuccessfulAction =
					{
						type: OpportunitiesActionTypes.FETCH_UPDATED_OPPORTUNITY_SUCCESSFUL,
						opportunity: updatedOpportunityResponse
					};
				return dispatch(opportunityDetailsSuccessfulAction);
			} catch (error) {
				const fetchUpdatedOpportunityFailedAction: FetchUpdatedOpportunityFailedAction =
					{
						type: OpportunitiesActionTypes.FETCH_UPDATED_OPPORTUNITY_FAILED
					};
				dispatch(fetchUpdatedOpportunityFailedAction);

				return Promise.reject(error);
			}
		};
	},
	fetchOpportunityForStageId:
		({
			stageId,
			fetchMoreOpportunitiesRequest
		}: {
			stageId: string;
			fetchMoreOpportunitiesRequest: ListPagePostRequest;
		}) =>
		async (
			dispatch: Dispatch,
			getState: () => GlobalState
		): Promise<FetchOpportunityKanbanSuccessfulAction> => {
			try {
				const fetchOpportunityKanbanRequestedAction: FetchOpportunityKanbanRequestedAction =
					{
						type: OpportunitiesActionTypes.FETCH_OPPORTUNITY_KANBAN_REQUESTED
					};
				dispatch(fetchOpportunityKanbanRequestedAction);

				const currentActivePipeline =
					getState().pipelines.currentActivePipeline;

				if (!currentActivePipeline) {
					throw new Error("No current active pipeline");
				}

				const pipelineFilter: CustomViewFilterCriteria = {
					field_display_name: "",
					filter_entity_type: ZomentumEntities.Opportunity,
					field_name: "opportunity_pipeline_id",
					filter_operator: {
						id_value:
							SalesActivityAutomationMetadataFilterOperator.Is,
						display_value: "Is",
						value_type: null
					},
					values: [
						{
							id_value: currentActivePipeline.id,
							display_value: "",
							value_type: null
						}
					],
					linked_entity_type: null
				};

				const stageIdFilter: CustomViewFilterCriteria = {
					field_display_name: "",
					filter_entity_type: ZomentumEntities.Opportunity,
					field_name: "opportunity_pipeline_stage_id",
					filter_operator: {
						id_value:
							SalesActivityAutomationMetadataFilterOperator.Is,
						display_value: "Is",
						value_type: null
					},
					values: [
						{
							id_value: stageId,
							display_value: "",
							value_type: null
						}
					],
					linked_entity_type: null
				};

				const updatedOpportunitiesRequest: ListPagePostRequest = {
					...fetchMoreOpportunitiesRequest,
					filter_criterion: [
						...fetchMoreOpportunitiesRequest.filter_criterion,
						pipelineFilter,
						stageIdFilter
					],
					included_child_entities: [
						...fetchMoreOpportunitiesRequest.included_child_entities,
						ChildEntityHydrationParams.CLIENT_COMPANIES_NAME,
						ChildEntityHydrationParams.CLIENT_COMPANY_SYNC_DATA,
						ChildEntityHydrationParams.OPPORTUNITY_ACTION_STATUS
					]
				};

				const response = await getOpportunityListPost(
					updatedOpportunitiesRequest
				);

				const list = response.data.map(opp => opp.id);
				const data = response.data.reduce(
					(total, curr) => ({ ...total, [curr.id]: curr }),
					{}
				);
				const prevList =
					getState().opportunities.kanban.list[stageId] || [];
				const pageNumber = fetchMoreOpportunitiesRequest.page_no;

				const fetchOpportunityKanbanSuccessfulAction: FetchOpportunityKanbanSuccessfulAction =
					{
						type: OpportunitiesActionTypes.FETCH_OPPORTUNITY_KANBAN_SUCCESSFUL,
						stageId,
						list: pageNumber > 1 ? [...prevList, ...list] : list,
						data
					};
				return dispatch(fetchOpportunityKanbanSuccessfulAction);
			} catch (error) {
				console.error(error);
				const fetchOpportunityKanbanFailedAction: FetchOpportunityKanbanFailedAction =
					{
						type: OpportunitiesActionTypes.FETCH_OPPORTUNITY_KANBAN_FAILED
					};
				dispatch(fetchOpportunityKanbanFailedAction);

				return Promise.reject(error);
			}
		},
	reorderOpportunityInKanban:
		(
			result: DropResult,
			terminatedReasons?: Pick<
				EditOpportunityRequest,
				"won_reason" | "loss_reason"
			>
		) =>
		async (
			dispatch: Dispatch,
			getState: () => GlobalState
		): Promise<UpdateOpportunityOnKanbanAction> => {
			try {
				const updateOpportunityKanbanRequestedAction: UpdateOpportunityKanbanRequestedAction =
					{
						type: OpportunitiesActionTypes.UPDATE_OPPORTUNITY_KANBAN_REQUESTED
					};
				dispatch(updateOpportunityKanbanRequestedAction);

				let kanban = { ...getState().opportunities.kanban };
				const kanbanData = { ...getState().opportunities.kanban.data };

				if (!result.destination) {
					throw new Error("DroppableID is not available");
				}
				const {
					source: {
						droppableId: sourceDroppableId,
						index: sourceDroppableIndex
					},
					destination: {
						droppableId: destDroppableId,
						index: destDroppableIndex
					},
					draggableId
				} = result;

				const selectedOpportunity = kanbanData[draggableId];
				const selectedEstimatedValue =
					selectedOpportunity.estimated_value ?? 0;
				const sourceOpportunityStageId =
					sourceDroppableId.split("::")[1];
				const destOpportunityStageId = destDroppableId.split("::")[1];

				const sourceList = [
					...(kanban.list[sourceOpportunityStageId] ?? [])
				];
				const destList = [
					...(kanban.list[destOpportunityStageId] ?? [])
				];
				const selectedOpportunityId = sourceList[sourceDroppableIndex];

				let updatedPositionData: Record<string, any[]>;

				const hasChangedStages =
					sourceOpportunityStageId !== destOpportunityStageId;

				if (!hasChangedStages) {
					updatedPositionData = {
						[sourceOpportunityStageId]: reorder(
							sourceList,
							sourceDroppableIndex,
							destDroppableIndex
						)
					};
				} else {
					updatedPositionData = move(
						sourceList,
						destList,
						{
							droppableId: sourceOpportunityStageId,
							index: sourceDroppableIndex
						},
						{
							droppableId: destOpportunityStageId,
							index: destDroppableIndex
						}
					);
				}

				if (hasChangedStages) {
					const updateOpportunityKanbanSuccessfulAction: UpdateOpportunityKanbanSuccessfulAction =
						{
							type: OpportunitiesActionTypes.UPDATE_OPPORTUNITY_KANBAN_SUCCESSFUL,
							kanban: {
								list: {
									...kanban.list,
									...updatedPositionData
								},
								count: {
									...kanban.count,
									[sourceOpportunityStageId]:
										kanban.count[sourceOpportunityStageId] -
										1,
									[destOpportunityStageId]:
										kanban.count[destOpportunityStageId] + 1
								},
								estimated_value: {
									...kanban.estimated_value,
									[sourceOpportunityStageId]:
										kanban.estimated_value[
											sourceOpportunityStageId
										] - selectedEstimatedValue,
									[destOpportunityStageId]:
										kanban.estimated_value[
											destOpportunityStageId
										] + selectedEstimatedValue
								}
							}
						};
					dispatch(updateOpportunityKanbanSuccessfulAction);
				}

				kanban = { ...getState().opportunities.kanban };
				const oldOpportunityData: Opportunity = {
					...getState().opportunities.kanban.data[
						selectedOpportunityId
					],
					documents: undefined
				};
				oldOpportunityData.custom_fields = filterOutFormulaFields(
					oldOpportunityData.custom_fields
				);
				delete oldOpportunityData.opportunity_vendor_details;
				const opportunityUpdateRequest: EditOpportunityRequest = {
					...oldOpportunityData,
					...terminatedReasons,
					currency: getOpportunityCurrencyCode(
						oldOpportunityData.currency
					),
					opportunity_pipeline_stage_id: destOpportunityStageId,
					included_child_entities: [
						ChildEntityHydrationParams.CLIENT_COMPANIES_NAME,
						ChildEntityHydrationParams.CLIENT_COMPANY_SYNC_DATA,
						ChildEntityHydrationParams.OPPORTUNITY_ACTION_STATUS,
						ChildEntityHydrationParams.DOCUMENTS_ALL
					],
					mandatory_custom_field_check_require: false
				};

				const opportunityResponse = await editOpportunity(
					opportunityUpdateRequest
				);

				const updateOpportunityOnKanbanAction: UpdateOpportunityOnKanbanAction =
					{
						type: OpportunitiesActionTypes.UPDATE_OPPORTUNITY_ON_KANBAN,
						opportunity: opportunityResponse
					};
				return dispatch(updateOpportunityOnKanbanAction);
			} catch (error) {
				// revert actions
				// if (result.destination) {

				// 	const {
				// 		source: { droppableId: sourceDroppableId, index: sourceDroppableIndex },
				// 		destination: { droppableId: destDroppableId, index: destDroppableIndex }
				// 	} = result;
				// 	const sourceOpportunityStageId = sourceDroppableId.split('::')[1];
				// 	const destOpportunityStageId = destDroppableId.split('::')[1];
				// 	const hasChangedStages = sourceOpportunityStageId !== destOpportunityStageId;

				// 	if (hasChangedStages) {
				// 	}
				// }

				console.error(error);
				const updateOpportunityKanbanFailedAction: UpdateOpportunityKanbanFailedAction =
					{
						type: OpportunitiesActionTypes.UPDATE_OPPORTUNITY_KANBAN_FAILED
					};
				dispatch(updateOpportunityKanbanFailedAction);

				return Promise.reject(error);
			}
		},
	updateOpportunityOnKanban:
		(opportunity: Opportunity) =>
		(
			dispatch: Dispatch,
			getState: () => GlobalState
		): UpdateOpportunityOnKanbanAction => {
			const prevOpportunityStage =
				getState().opportunities.kanban.data[opportunity.id];
			const prevKanban = getState().opportunities.kanban;
			const {
				count: prevKanbanCount,
				list: prevKanbanList,
				estimated_value: prevKanbanEstimatedValue,
				data: prevKanbanData
			} = prevKanban;
			const activeUsers = getState().opportunities.activeUsers;

			const selectedEstimatedValue = opportunity.estimated_value ?? 0;

			// checking for the opportunity stage change for the count in kanban header
			const currOppPipelineId = opportunity.opportunity_pipeline_id;
			const prevOppPipelineId =
				prevOpportunityStage.opportunity_pipeline_id;
			const currOppStageId = opportunity.opportunity_pipeline_stage_id;
			const prevOppStageId =
				prevOpportunityStage.opportunity_pipeline_stage_id;
			const currentOpportunityId = opportunity.id;
			const hasOpportunityPipelineChanged =
				prevOppPipelineId !== currOppPipelineId;
			const hasOpportunityStageChanged =
				prevOppStageId !== currOppStageId;
			// remove opportunity from state if pipeline for that opportunity is changed
			if (hasOpportunityPipelineChanged) {
				const updateOpportunityKanbanSuccessfulAction: UpdateOpportunityKanbanSuccessfulAction =
					{
						type: OpportunitiesActionTypes.UPDATE_OPPORTUNITY_KANBAN_SUCCESSFUL,
						kanban: {
							count: {
								...prevKanbanCount,
								[prevOppStageId]:
									prevKanbanCount[prevOppStageId] - 1
							},
							list: {
								...prevKanbanList,
								[prevOppStageId]: prevKanbanList[
									prevOppStageId
								].filter(
									opportunity =>
										opportunity !== currentOpportunityId
								)
							},
							estimated_value: {
								...prevKanbanEstimatedValue,
								[prevOppStageId]:
									prevKanbanEstimatedValue[prevOppStageId] -
									selectedEstimatedValue
							}
						}
					};
				dispatch(updateOpportunityKanbanSuccessfulAction);
			}

			if (!hasOpportunityPipelineChanged && hasOpportunityStageChanged) {
				const updateOpportunityKanbanSuccessfulAction: UpdateOpportunityKanbanSuccessfulAction =
					{
						type: OpportunitiesActionTypes.UPDATE_OPPORTUNITY_KANBAN_SUCCESSFUL,
						kanban: {
							count: {
								...prevKanbanCount,
								[currOppStageId]:
									prevKanbanCount[currOppStageId] + 1,
								[prevOppStageId]:
									prevKanbanCount[prevOppStageId] - 1
							},
							list: {
								...prevKanbanList,
								[prevOppStageId]: prevKanbanList[
									prevOppStageId
								].filter(
									opportunity =>
										opportunity !== currentOpportunityId
								),
								[currOppStageId]: [
									...prevKanbanList[currOppStageId],
									currentOpportunityId
								]
							},
							estimated_value: {
								...prevKanbanEstimatedValue,
								[currOppStageId]:
									prevKanbanEstimatedValue[currOppStageId] +
									selectedEstimatedValue,
								[prevOppStageId]:
									prevKanbanEstimatedValue[prevOppStageId] -
									selectedEstimatedValue
							}
						}
					};
				dispatch(updateOpportunityKanbanSuccessfulAction);
			}

			// checking for opportunity owner
			const isUserFilterActive = activeUsers?.length > 0;
			const ownerChangedOutOfActiveFilter =
				isUserFilterActive &&
				!activeUsers.includes(opportunity.owner_user_id);

			if (
				!hasOpportunityPipelineChanged &&
				ownerChangedOutOfActiveFilter
			) {
				const updateOpportunityKanbanSuccessfulAction: UpdateOpportunityKanbanSuccessfulAction =
					{
						type: OpportunitiesActionTypes.UPDATE_OPPORTUNITY_KANBAN_SUCCESSFUL,
						kanban: {
							...prevKanban,
							count: {
								...prevKanban.count,
								[currOppStageId]:
									prevKanbanCount[currOppStageId] - 1
							},
							list: {
								...prevKanban.list,
								[currOppStageId]: prevKanban.list[
									currOppStageId
								].filter(currId => currId !== opportunity.id)
							},
							estimated_value: {
								...prevKanban.estimated_value,
								[currOppStageId]:
									prevKanbanEstimatedValue[currOppStageId] -
									selectedEstimatedValue
							}
						}
					};
				dispatch(updateOpportunityKanbanSuccessfulAction);
			}

			const estimatedValueChanged =
				prevKanbanData[currentOpportunityId].estimated_value !==
				opportunity.estimated_value;

			if (
				!ownerChangedOutOfActiveFilter &&
				!hasOpportunityStageChanged &&
				!hasOpportunityPipelineChanged &&
				estimatedValueChanged
			) {
				const prevValue =
					prevKanbanData[currentOpportunityId].estimated_value ?? 0;
				const updateOpportunityKanbanSuccessfulAction: UpdateOpportunityKanbanSuccessfulAction =
					{
						type: OpportunitiesActionTypes.UPDATE_OPPORTUNITY_KANBAN_SUCCESSFUL,
						kanban: {
							...prevKanban,
							estimated_value: {
								...prevKanban.estimated_value,
								[currOppStageId]:
									prevKanbanEstimatedValue[currOppStageId] -
									prevValue +
									selectedEstimatedValue
							}
						}
					};
				dispatch(updateOpportunityKanbanSuccessfulAction);
			}

			const updateOpportunityKanbanFailedAction: UpdateOpportunityOnKanbanAction =
				{
					type: OpportunitiesActionTypes.UPDATE_OPPORTUNITY_ON_KANBAN,
					opportunity
				};
			return dispatch(updateOpportunityKanbanFailedAction);
		},
	acceptPendingOpportunity:
		(opportunity: Opportunity) =>
		(dispatch: Dispatch): AddOpportunityOnKanbanAction => {
			const addOpportunityOnKanbanAction: AddOpportunityOnKanbanAction = {
				type: OpportunitiesActionTypes.ADD_OPPORTUNITY_ON_KANBAN,
				opportunity
			};
			return dispatch(addOpportunityOnKanbanAction);
		},
	deleteOpportunityOnKanban:
		(args: { opportunityId: string; opportunityStageId: string }) =>
		(
			dispatch: Dispatch,
			getState: () => GlobalState
		): DeleteOpportunityOnKanbanAction => {
			const kanbanData = { ...getState().opportunities.kanban.data };
			const selectedOpportunity = kanbanData[args.opportunityId];
			const selectedEstimatedValue =
				selectedOpportunity.estimated_value ?? 0;
			const deleteOpportunityOnKanbanAction: DeleteOpportunityOnKanbanAction =
				{
					type: OpportunitiesActionTypes.DELETE_OPPORTUNITY_ON_KANBAN,
					...args,
					selectedEstimatedValue
				};
			return dispatch(deleteOpportunityOnKanbanAction);
		},
	updateActiveUsers:
		users =>
		(dispatch: Dispatch): UpdateOpportunityUserFilterAction => {
			const updateOpportunityUserFilterAction: UpdateOpportunityUserFilterAction =
				{
					type: OpportunitiesActionTypes.UPDATE_OPPORTUNITY_USER_FILTER,
					activeUsers: users
				};
			return dispatch(updateOpportunityUserFilterAction);
		},
	fetchAllOpportunitiesForKanban: (
		fetchOpportunityKanbanRequest: ListPagePostRequest
	) => {
		return async (
			dispatch: Dispatch,
			getState: () => GlobalState
		): Promise<FetchAllOpportunitiesForKanbanSuccessfulAction> => {
			const fetchAllOpportunitiesForKanbanRequestedAction: FetchAllOpportunitiesForKanbanRequestedAction =
				{
					type: OpportunitiesActionTypes.FETCH_ALL_OPPORTUNITIES_FOR_KANBAN_REQUESTED
				};
			dispatch(fetchAllOpportunitiesForKanbanRequestedAction);
			try {
				const activePipelineId =
					getState().pipelines.currentActivePipeline?.id;

				const updatedFilters =
					activePipelineId && !isAllPipelinesFilter(activePipelineId)
						? getUpdatedFiltersWithPipelineFilters(
								activePipelineId,
								fetchOpportunityKanbanRequest.filter_criterion
						  )
						: fetchOpportunityKanbanRequest.filter_criterion ?? [];

				const opportunityRequest: ListPagePostRequest = {
					...fetchOpportunityKanbanRequest,
					filter_criterion: [...updatedFilters],
					included_child_entities: [
						...fetchOpportunityKanbanRequest.included_child_entities
					]
				};
				const prevKanban = getState().opportunities.kanban;
				const response = await getOpportunitiesForKanbanPost(
					opportunityRequest
				);
				const data = response.opportunity_stages.reduce(
					(total, current) => {
						let tempData = {};
						current.opportunities.forEach(
							(opportunity: Opportunity) => {
								tempData = {
									...tempData,
									[opportunity.id]: opportunity
								};
							}
						);
						return {
							...total,
							...tempData
						};
					},
					{}
				);
				const list = response.opportunity_stages.reduce(
					(total, current) => {
						return {
							...total,
							[current.id]: current.opportunities.map(o => o.id)
						};
					},
					{}
				);
				const updatedKanban: KanbanState = {
					...prevKanban,
					data: data,
					list: list
				};

				const fetchAllOpportunitiesForKanbanSuccessfulAction: FetchAllOpportunitiesForKanbanSuccessfulAction =
					{
						type: OpportunitiesActionTypes.FETCH_ALL_OPPORTUNITIES_FOR_KANBAN_SUCCESSFUL,
						kanban: updatedKanban
					};
				return dispatch(fetchAllOpportunitiesForKanbanSuccessfulAction);
			} catch (error) {
				const fetchAllOpportunitiesForKanbanFailedAction: FetchAllOpportunitiesForKanbanFailedAction =
					{
						type: OpportunitiesActionTypes.FETCH_ALL_OPPORTUNITIES_FOR_KANBAN_FAILED
					};
				dispatch(fetchAllOpportunitiesForKanbanFailedAction);

				return Promise.reject(error);
			}
		};
	},
	fetchAllOpportunitiesCountForKanban: (
		fetchOpportunityKanbanRequest: ListPagePostRequest
	) => {
		return async (
			dispatch: Dispatch,
			getState: () => GlobalState
		): Promise<FetchAllOpportunitiesCountForKanbanSuccessfulAction> => {
			const fetchAllOpportunitiesCountForKanbanRequestedAction: FetchAllOpportunitiesCountForKanbanRequestedAction =
				{
					type: OpportunitiesActionTypes.FETCH_ALL_OPPORTUNITIES_COUNT_FOR_KANBAN_REQUESTED
				};
			dispatch(fetchAllOpportunitiesCountForKanbanRequestedAction);
			try {
				const pipelineId =
					getState().pipelines.currentActivePipeline?.id;
				const updatedFilters =
					pipelineId && !isAllPipelinesFilter(pipelineId)
						? getUpdatedFiltersWithPipelineFilters(
								pipelineId,
								fetchOpportunityKanbanRequest.filter_criterion
						  )
						: fetchOpportunityKanbanRequest.filter_criterion ?? [];

				const opportunityRequest: ListPagePostRequest = {
					...fetchOpportunityKanbanRequest,
					filter_criterion: [...updatedFilters]
				};
				const prevKanban = getState().opportunities.kanban;
				const response = await getOpportunitiesCountForKanbanPost(
					opportunityRequest
				);
				const count = response.reduce((total, current) => {
					return {
						...total,
						[current.opportunity_stage_id]:
							current.opportunity_count
					};
				}, {});
				const estimatedValue = response.reduce((total, current) => {
					return {
						...total,
						[current.opportunity_stage_id]:
							current.opportunities_estimated_value
					};
				}, {});
				const updatedKanban: KanbanState = {
					...prevKanban,
					count: count,
					estimated_value: estimatedValue
				};
				const fetchAllOpportunitiesCountForKanbanSuccessfulAction: FetchAllOpportunitiesCountForKanbanSuccessfulAction =
					{
						type: OpportunitiesActionTypes.FETCH_ALL_OPPORTUNITIES_COUNT_FOR_KANBAN_SUCCESSFUL,
						kanban: updatedKanban
					};
				return dispatch(
					fetchAllOpportunitiesCountForKanbanSuccessfulAction
				);
			} catch (error) {
				const fetchAllOpportunitiesCountForKanbanFailedAction: FetchAllOpportunitiesCountForKanbanFailedAction =
					{
						type: OpportunitiesActionTypes.FETCH_ALL_OPPORTUNITIES_COUNT_FOR_KANBAN_FAILED
					};
				dispatch(fetchAllOpportunitiesCountForKanbanFailedAction);

				return Promise.reject(error);
			}
		};
	},
	updateOpportunityDocument: (document: Document) => {
		return (
			dispatch: Dispatch,
			getState: () => GlobalState
		): UpdateOpportunityDocumentAction => {
			const documents =
				getState().opportunities.currentActiveOpportunity?.documents
					?.data;
			let updatedDocuments: Document[] = new Array<Document>();
			if (documents) {
				updatedDocuments = documents?.map(doc => {
					if (doc.id === document.id) {
						return document;
					} else {
						return doc;
					}
				});
			}
			// If the document details are updated including changing the opportunity the document
			// needs to be excluded from the currentActiveOpportunity
			updatedDocuments = updatedDocuments.filter(
				doc =>
					(doc.id === document.id &&
						doc.opportunity_id !== document.opportunity_id) ||
					doc.id !== document.id
			);
			const updateOpportunityDocumentAction: UpdateOpportunityDocumentAction =
				{
					type: OpportunitiesActionTypes.UPDATE_OPPORTUNITY_DOCUMENT,
					documents: updatedDocuments
				};
			return dispatch(updateOpportunityDocumentAction);
		};
	},
	fetchOpportunityViewMetadata: () => {
		return async (
			dispatch: Dispatch
		): Promise<FetchOpportunityViewMetadataSuccessful> => {
			const fetchViewMetadataRequested: FetchOpportunityViewMetadataRequested =
				{
					type: OpportunitiesActionTypes.FETCH_OPPORTUNITY_VIEW_METADATA_REQUESTED
				};

			dispatch(fetchViewMetadataRequested);

			try {
				const response = await getOpportunityViewMetadata();
				const fetchViewMetadataSuccessful: FetchOpportunityViewMetadataSuccessful =
					{
						type: OpportunitiesActionTypes.FETCH_OPPORTUNITY_VIEW_METADATA_SUCCESSFUL,
						metadata: response
					};
				return dispatch(fetchViewMetadataSuccessful);
			} catch (error) {
				console.error(error);

				const fetchViewMetadataFailed: FetchOpportunityViewMetadataFailed =
					{
						type: OpportunitiesActionTypes.FETCH_OPPORTUNITY_VIEW_METADATA_FAILED
					};
				dispatch(fetchViewMetadataFailed);

				return Promise.reject(error);
			}
		};
	},
	fetchAllOpportunityView: () => {
		return async (
			dispatch: Dispatch
		): Promise<FetchAllOpportunityViewSuccessful> => {
			const fetchAllOpportunityViewRequested: FetchAllOpportunityViewRequested =
				{
					type: OpportunitiesActionTypes.FETCH_ALL_OPPORTUNITY_VIEWS_REQUESTED
				};

			dispatch(fetchAllOpportunityViewRequested);

			try {
				const response = await getAllOpportunityViews();
				const fetchAllOpportunityViewSuccessful: FetchAllOpportunityViewSuccessful =
					{
						type: OpportunitiesActionTypes.FETCH_ALL_OPPORTUNITY_VIEWS_SUCCESSFUL,
						viewList: response
					};
				return dispatch(fetchAllOpportunityViewSuccessful);
			} catch (error) {
				console.error(error);

				const fetchAllOpportunityViewFailed: FetchAllOpportunityViewFailed =
					{
						type: OpportunitiesActionTypes.FETCH_ALL_OPPORTUNITY_VIEWS_FAILED
					};
				dispatch(fetchAllOpportunityViewFailed);

				return Promise.reject(error);
			}
		};
	},
	fetchAllOpportunities: (clientRequest: ListPagePostRequest) => {
		return async (
			dispatch: Dispatch
		): Promise<FetchOpportunityListSuccessful> => {
			const fetchOpportunityListRequested: FetchOpportunityListRequested =
				{
					type: OpportunitiesActionTypes.FETCH_OPPORTUNITY_LIST_REQUESTED
				};
			dispatch(fetchOpportunityListRequested);
			try {
				const response = await getOpportunityListPost(clientRequest);

				const fetchOpportunityListSuccessful: FetchOpportunityListSuccessful =
					{
						type: OpportunitiesActionTypes.FETCH_OPPORTUNITY_LIST_SUCCESSFUL,
						opportunityList: response.data,
						count: response.filtered_count_map
					};

				return dispatch(fetchOpportunityListSuccessful);
			} catch (error) {
				const fetchOpportunityListFailed: FetchOpportunityListFailed = {
					type: OpportunitiesActionTypes.FETCH_OPPORTUNITY_LIST_FAILED
				};

				dispatch(fetchOpportunityListFailed);

				return Promise.reject(error);
			}
		};
	},
	updateCurrentActiveView: (
		selectedCurrentActiveView: CustomView,
		discardingView?: boolean
	) => {
		return (
			dispatch: Dispatch,
			getState: () => GlobalState
		): UpdateCurrentActiveViewAction => {
			const currentActiveView =
				getState().opportunities.currentActiveView;
			const prevViewData = getState().opportunities.viewList?.data.find(
				view => view.id === selectedCurrentActiveView?.id
			);

			const isSameView =
				currentActiveView?.id === selectedCurrentActiveView?.id;

			if (isSameView) {
				// if its a custom view then it would have an id
				if (!!prevViewData) {
					const hasFiltersChanged = areFiltersChanged(
						prevViewData.filter_criteria,
						selectedCurrentActiveView.filter_criteria
					);

					const hasColumnsChanged =
						JSON.stringify(selectedCurrentActiveView.columns) !==
						JSON.stringify(prevViewData.columns);

					const updateCurrentActiveViewAction: UpdateCurrentActiveViewAction =
						{
							type: OpportunitiesActionTypes.UPDATE_OPPORTUNITY_CURRENT_ACTIVE_VIEW,
							currentActiveView: selectedCurrentActiveView,
							isViewChanged: discardingView
								? false
								: hasFiltersChanged || hasColumnsChanged
						};
					return dispatch(updateCurrentActiveViewAction);
				}
			}

			const updateCurrentActiveViewAction: UpdateCurrentActiveViewAction =
				{
					type: OpportunitiesActionTypes.UPDATE_OPPORTUNITY_CURRENT_ACTIVE_VIEW,
					currentActiveView: selectedCurrentActiveView,
					isViewChanged: discardingView ? true : false
				};
			return dispatch(updateCurrentActiveViewAction);
		};
	},
	createOpportunityView: (view: CustomView) => {
		return async (
			dispatch: Dispatch
		): Promise<CreateOpportunityViewSuccessfulAction> => {
			const createOpportunityViewRequestedAction: CreateOpportunityViewRequestedAction =
				{
					type: OpportunitiesActionTypes.CREATE_OPPORTUNITY_VIEW_REQUESTED
				};

			dispatch(createOpportunityViewRequestedAction);

			try {
				const response = await createOpportunityView(view);
				const createOpportunityViewSuccessfulAction: CreateOpportunityViewSuccessfulAction =
					{
						type: OpportunitiesActionTypes.CREATE_OPPORTUNITY_VIEW_SUCCESSFUL,
						view: response
					};
				return dispatch(createOpportunityViewSuccessfulAction);
			} catch (error) {
				const createOpportunityViewFailedAction: CreateOpportunityViewFailedAction =
					{
						type: OpportunitiesActionTypes.CREATE_OPPORTUNITY_VIEW_FAILED
					};
				dispatch(createOpportunityViewFailedAction);

				return Promise.reject(error);
			}
		};
	},
	updateOpportunityView: (view: CustomView) => {
		return async (
			dispatch: Dispatch
		): Promise<UpdateOpportunityViewSuccessfulAction> => {
			const updateOpportunityViewRequestedAction: UpdateOpportunityViewRequestedAction =
				{
					type: OpportunitiesActionTypes.UPDATE_OPPORTUNITY_VIEW_REQUESTED
				};

			dispatch(updateOpportunityViewRequestedAction);

			try {
				const response = await updateOpportunityView(view);
				const updateOpportunityViewSuccessfulAction: UpdateOpportunityViewSuccessfulAction =
					{
						type: OpportunitiesActionTypes.UPDATE_OPPORTUNITY_VIEW_SUCCESSFUL,
						view: response
					};
				return dispatch(updateOpportunityViewSuccessfulAction);
			} catch (error) {
				const updateOpportunityViewFailedAction: UpdateOpportunityViewFailedAction =
					{
						type: OpportunitiesActionTypes.UPDATE_OPPORTUNITY_VIEW_FAILED
					};
				dispatch(updateOpportunityViewFailedAction);

				return Promise.reject(error);
			}
		};
	},
	deleteOpportunityView: (
		deleteView: CustomView,
		initialView: CustomView
	) => {
		return async (
			dispatch: Dispatch
		): Promise<DeleteOpportunityViewSuccessfulAction> => {
			const deleteOpportunityViewRequestedAction: DeleteOpportunityViewRequestedAction =
				{
					type: OpportunitiesActionTypes.DELETE_OPPORTUNITY_VIEW_REQUESTED
				};

			dispatch(deleteOpportunityViewRequestedAction);

			try {
				await deleteOpportunityView(deleteView.id);
				const deleteOpportunityViewSuccessfulAction: DeleteOpportunityViewSuccessfulAction =
					{
						type: OpportunitiesActionTypes.DELETE_OPPORTUNITY_VIEW_SUCCESSFUL,
						deletedView: deleteView,
						initialView: initialView
					};
				return dispatch(deleteOpportunityViewSuccessfulAction);
			} catch (error) {
				const deleteOpportunityViewFailedAction: DeleteOpportunityViewFailedAction =
					{
						type: OpportunitiesActionTypes.DELETE_OPPORTUNITY_VIEW_FAILED
					};
				dispatch(deleteOpportunityViewFailedAction);

				return Promise.reject(error);
			}
		};
	},
	resetViews: () => {
		return (dispatch: Dispatch): ResetCurrentActiveViewAction => {
			const resetCurrentActiveViewAction: ResetCurrentActiveViewAction = {
				type: OpportunitiesActionTypes.RESET_OPPORTUNITY_CURRENT_ACTIVE_VIEW
			};

			return dispatch(resetCurrentActiveViewAction);
		};
	},
	bulkActionsRecordsSelected: () => {
		return (dispatch: Dispatch): BulkActionRecordsSelectedAction => {
			const bulkActionRecordsSelectedAction: BulkActionRecordsSelectedAction =
				{
					type: OpportunitiesActionTypes.BULK_ACTION_RECORDS_SELECTED
				};

			return dispatch(bulkActionRecordsSelectedAction);
		};
	},
	bulkActionsRecordsReset: () => {
		return (dispatch: Dispatch): BulkActionRecordsResetAction => {
			const bulkActionRecordsResetAction: BulkActionRecordsResetAction = {
				type: OpportunitiesActionTypes.BULK_ACTION_RECORDS_RESET
			};

			return dispatch(bulkActionRecordsResetAction);
		};
	},
	bulkDeleteRecords: (deleteRecordsRequest: BulkDeleteRecordsRequest) => {
		return async (
			dispatch: Dispatch
		): Promise<BulkDeleteRecordsSuccessfulAction> => {
			const bulkDeleteRecordsRequestedAction: BulkDeleteRecordsRequestedAction =
				{
					type: OpportunitiesActionTypes.BULK_DELETE_RECORDS_REQUESTED
				};

			dispatch(bulkDeleteRecordsRequestedAction);

			try {
				await bulkDeleteRecords(deleteRecordsRequest);

				const bulkDeleteRecordsSuccessfulAction: BulkDeleteRecordsSuccessfulAction =
					{
						type: OpportunitiesActionTypes.BULK_DELETE_RECORDS_SUCCESSFUL
					};

				return dispatch(bulkDeleteRecordsSuccessfulAction);
			} catch (error) {
				const bulkDeleteRecordsFailedAction: BulkDeleteRecordsFailedAction =
					{
						type: OpportunitiesActionTypes.BULK_DELETE_RECORDS_FAILED
					};
				dispatch(bulkDeleteRecordsFailedAction);

				return Promise.reject(error);
			}
		};
	},
	bulkUpdateRecords: (updateRecordsRequest: BulkUpdateRecordsRequest) => {
		return async (
			dispatch: Dispatch
		): Promise<BulkUpdateRecordsSuccessfulAction> => {
			const bulkUpdateRecordsRequestedAction: BulkUpdateRecordsRequestedAction =
				{
					type: OpportunitiesActionTypes.BULK_UPDATE_RECORDS_REQUESTED
				};

			dispatch(bulkUpdateRecordsRequestedAction);

			try {
				await bulkUpdateRecords(updateRecordsRequest);

				const bulkUpdateRecordsSuccessfulAction: BulkUpdateRecordsSuccessfulAction =
					{
						type: OpportunitiesActionTypes.BULK_UPDATE_RECORDS_SUCCESSFUL
					};

				return dispatch(bulkUpdateRecordsSuccessfulAction);
			} catch (error) {
				const bulkUpdateRecordsFailedAction: BulkUpdateRecordsFailedAction =
					{
						type: OpportunitiesActionTypes.BULK_UPDATE_RECORDS_FAILED
					};
				dispatch(bulkUpdateRecordsFailedAction);

				return Promise.reject(error);
			}
		};
	},
	fetchDocumentRelatedToOpportunity: (opportunityId: string) => {
		return async (
			dispatch: Dispatch
		): Promise<FetchOpportunityDocumentSuccessfulAction> => {
			const fetchOpportunityDocumentRequestedAction: FetchOpportunityDocumentRequestedAction =
				{
					type: OpportunitiesActionTypes.FETCH_OPPORTUNITY_DOCUMENTS_REQUESTED
				};

			dispatch(fetchOpportunityDocumentRequestedAction);

			try {
				const response = await getOpportunityDocuments(opportunityId);

				const fetchOpportunityDocumentSuccessfulAction: FetchOpportunityDocumentSuccessfulAction =
					{
						type: OpportunitiesActionTypes.FETCH_OPPORTUNITY_DOCUMENTS_SUCCESSFUL,
						opportunity: response
					};

				return dispatch(fetchOpportunityDocumentSuccessfulAction);
			} catch (error) {
				const fetchOpportunityDocumentFailedAction: FetchOpportunityDocumentFailedAction =
					{
						type: OpportunitiesActionTypes.FETCH_OPPORTUNITY_DOCUMENTS_FAILED
					};

				dispatch(fetchOpportunityDocumentFailedAction);

				return Promise.reject(error);
			}
		};
	},
	fetchRecentDocumentByOpportunityIds: (opportunityIds: string[]) => {
		return async (
			dispatch: Dispatch
		): Promise<MergeRecentDocumentForOpportunitiesAction> => {
			const map: Record<string, RecentDocumentItemView | null> = {};
			if (!opportunityIds.length) {
				const emptyAction: MergeRecentDocumentForOpportunitiesAction = {
					type: OpportunitiesActionTypes.MERGE_RECENT_DOCUMENT_FOR_OPPORTUNITIES,
					map
				};
				return dispatch(emptyAction);
			}
			opportunityIds.forEach(id => {
				map[id] = null;
			});
			try {
				const response = await getRecentDocumentsByOpportunityIds(
					opportunityIds
				);
				response.data.forEach(item => {
					if (item.opportunity_id) {
						map[item.opportunity_id] = item;
					}
				});
			} catch (error) {
				console.error(error);
			}
			const action: MergeRecentDocumentForOpportunitiesAction = {
				type: OpportunitiesActionTypes.MERGE_RECENT_DOCUMENT_FOR_OPPORTUNITIES,
				map
			};
			return dispatch(action);
		};
	},
	fetchRecentActivityByOpportunityIds: (opportunityIds: string[]) => {
		return async (
			dispatch: Dispatch
		): Promise<MergeRecentActivityForOpportunitiesAction> => {
			const map: Record<string, RecentActivityItemView | null> = {};
			if (!opportunityIds.length) {
				const emptyAction: MergeRecentActivityForOpportunitiesAction = {
					type: OpportunitiesActionTypes.MERGE_RECENT_ACTIVITY_FOR_OPPORTUNITIES,
					map
				};
				return dispatch(emptyAction);
			}
			opportunityIds.forEach(id => {
				map[id] = null;
			});
			try {
				const response = await getRecentActivitiesByOpportunityIds(
					opportunityIds
				);
				response.data.forEach(item => {
					if (item.entity_id) {
						map[item.entity_id] = item;
					}
				});
			} catch (error) {
				console.error(error);
			}
			const action: MergeRecentActivityForOpportunitiesAction = {
				type: OpportunitiesActionTypes.MERGE_RECENT_ACTIVITY_FOR_OPPORTUNITIES,
				map
			};
			return dispatch(action);
		};
	}
};

export default OpportunitiesActionCreators;
